import { getPlanDetails } from "../../../api/requests";
import {
  setLoadingMessage,
  removeLoadingMessage,
} from "../../../utils/setLoadingMessage";
import findStep from "../../../screens/bot/stepModules/findStep";
import addMoneyMask from "../../../utils/addMoneyMask";
import { tagPlanoSelecionado } from "../../../utils/sendTag";
import { selectItemTag } from "../../../utils/sendTag/index";
import trackConversacaoStep from "../../../utils/trackConversacaoStep";

export const createPlanDetailsHandler = (
  selectedplano,
  setConsorcioStore,
  setMessages,
  setCurrentStep,
  hasDesconto,
  fakeLoad,
) => {
  return async () => {
    selectItemTag();

    const planText = `${addMoneyMask(selectedplano.bemCredito)} em ${selectedplano.planoMeses} parcelas de ${addMoneyMask(selectedplano.planoValorParcela)}`;

    trackConversacaoStep({
      stepName: "mensagem_carrossel_planos",
      userMessage: planText,
      userOnly: true,
      metadata: {
        planoId: selectedplano.planoID,
        bemId: selectedplano.bemID,
        valorCredito: selectedplano.bemCredito,
        parcela: selectedplano.planoValorParcela,
        meses: selectedplano.planoMeses,
        valorParcelaPrimeiroPagto: selectedplano.planoValorPagamento,
      },
    });

    setMessages({
      id: "selected-plan",
      sender: "user",
      text: `<b>${addMoneyMask(selectedplano.bemCredito)}</b></br>em ${
        selectedplano.planoMeses
      } parcelas</br>de ${addMoneyMask(selectedplano.planoValorParcela)}`,
    });

    setLoadingMessage();

    try {
      const planDetails = await getPlanDetails();
      const { data } = planDetails.data;

      if (data.titulo && data.taxaAdmTotal) {
        setConsorcioStore(data, "fetchedPlanDetails");
        try {
          localStorage.setItem(
            "mycon_fetched_plan_details",
            JSON.stringify(data),
          );
        } catch (_) {}
      }

      if (window?.planos_disponiveis) {
        window.plano_selecionado = window.planos_disponiveis.filter(
          (plano) => plano.plano_id === String(data.planoID),
        )[0];

        tagPlanoSelecionado();
      }

      setTimeout(() => {
        removeLoadingMessage();

        if (hasDesconto) {
          setCurrentStep(findStep("mensagem_desconto_parcela").index);
        } else {
          setCurrentStep(findStep("confirmacao_informacoes").index);
        }
      }, fakeLoad);
    } catch (error) {
      console.log("error --->", error);
      setCurrentStep(findStep("erro_geral").index);
      removeLoadingMessage();
    }
  };
};
